import { Component, OnInit } from '@angular/core';
import { ErmDevOpsApiClientService, RegionUsageReport } from 'erm-sdk';
import * as _ from 'lodash';

@Component({
  standalone: false,
  selector: 'app-widget-stats',
  templateUrl: './stats-widget.component.html',
  styleUrls: ['./stats-widget.component.scss']
})
export class StatsWidgetComponent implements OnInit {
  isLoading = false;

  regionUsageReports?: RegionUsageReport[];

  constructor(
    private ermDevOpsApiClient: ErmDevOpsApiClientService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  refresh = async (): Promise<boolean> => {
    try {
      this.isLoading = true;
      const getRegionUsageResponse = await this.ermDevOpsApiClient.getRegionUsage();
      this.regionUsageReports = getRegionUsageResponse.body?.regionUsageReports;

      return true;
    }
    finally {
      this.isLoading = false;
    }
  }
}
